export const CONTENT_TYPE = {
  INCLUDE_NESTED_OBJECTS: "application/included-nested-resources+json",
  SESSION_TOKEN: "application/session-token+json"
}

